import CloseIcon from '@mui/icons-material/Close';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import React from 'react';

interface GeneralModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	content?: string | React.ReactNode;
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	customWidth?: string | number;
	actions?: React.ReactNode;
	fullScreenOnMobile?: boolean;
	styles?: {
		paperStyle?: object;
		titleStyle?: object;
		contentStyle?: object;
		actionsStyle?: object;
	};
}

export const GeneralMuiModal: React.FC<GeneralModalProps> = ({
	open,
	onClose,
	title,
	content,
	maxWidth = 'sm',
	customWidth,
	actions,
	fullScreenOnMobile = false,
	styles = {},
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth={customWidth ? undefined : maxWidth}
			fullWidth={!customWidth}
			fullScreen={fullScreenOnMobile && isMobile}
			sx={
				fullScreenOnMobile && isMobile
					? {}
					: {
							'& .MuiDialog-paper': {
								width: '1000px',
								borderRadius: '12px',
								...styles.paperStyle,
							},
						}
			}
		>
			<DialogTitle
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					...styles.titleStyle,
					fontSize: '20px',
				}}
			>
				<span
					className={
						'text-dark font-roboto-slab text-sm md:text-md  sm:text-xl font-700 leading-normal'
					}
				>
					{title}
				</span>
				<IconButton
					edge="end"
					color="inherit"
					onClick={(e) => {
						e.stopPropagation();
						onClose();
					}}
					aria-label="close"
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<hr />
			<DialogContent sx={{ ...styles.contentStyle }}>
				{typeof content === 'string' ? <Typography color="#7B809A">{content}</Typography> : content}
			</DialogContent>
			{actions && (
				<DialogActions sx={{ justifyContent: 'center', padding: 2, ...styles.actionsStyle }}>
					{actions}
				</DialogActions>
			)}
		</Dialog>
	);
};
